<template>
    <div class="travel-block" @click="toogleFlightSchedule" :class="{'travel-block--open': showTravelInfo}">
        <div class="travel-block__header">
            <span class="travel-block__header__title" v-text="title"></span>
            <span class="travel-block__header__date" v-if="formattedDate" v-text="formattedDate"></span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.65 223" class="travel-block__header__arrow"><path d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"/></svg>
        </div>
        <div class="travel-block__body">
            <div class="time-city">
                <h3 v-if="startTime" v-text="startTime"></h3>
                <span v-if="startCity" v-text="startCity"></span>
            </div>
            <div class="time-stop">
                <span class="time-stop__travel-length" v-if="totalTime" v-text="totalTime"></span>
                <span class="time-stop__stops" v-if="totalStops" v-text="totalStops"></span>
            </div>
            <div class="time-city">
                <h3 v-if="endTime" v-text="endTime"></h3>
                <span v-if="endCity" v-text="endCity"></span>
            </div>
            <transition name="flight-transition">
                <div class="flight-view" v-if="showTravelInfo">
                    <div class="flight-view__content">
                        <div class="flight-details">
                            <div class="flight-details__item" v-for="(leg, legKey) in legList" :key="legKey">
                                <div class="flight-details__departure">
                                    <p class="flight-details__time" v-text="formatTime(leg.departureDateTime)"></p>
                                    <p v-text="leg.departureAirport.name"></p>
                                </div>
                                <div class="flight-details__plane">
                                    <div class="flight-details__plane__icon">
                                        <img src="./../../img/icons/icon-plane-down.svg">
                                    </div>
                                    <p class="flight-details__plane__text">
                                        <span v-text="leg.flightCarrier.name"></span>
                                        <span v-text="leg.flightNumber"></span>
                                    </p>
                                </div>
                                <div class="flight-details__arrival">
                                    <p class="flight-details__time" v-text="formatTime(leg.arrivalDateTime)"></p>
                                    <p v-text="leg.arrivalAirport.name"></p>
                                </div>
                            </div>
                            <div class="flight-details__stop" v-for="(airportTime) in airportTimes" :key="airportTime.airport.code">
                                <p class="flight-details__stop__airport" v-text="airportTime.airport.name"></p>
                                <p class="flight-details__stop__time">{{ translations.time_in_airport }} {{ airportTime.time }}</p>
                            </div>

                            <div class="flight-details__stop flight-details__stop--total">
                                <p class="flight-details__stop__airport" v-text="translations.total_travel_time"></p>
                                <p class="flight-details__stop__time" v-text="totalTime"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script type="text/javascript">
    import Moment from 'moment';
    import _ from 'underscore';

    export default {
        props: {
            title: {type: String, default: ''},
            flightData: {type: Object, default: null}
        },
        data() {
            return {
                translations: APP_CONFIG.TRANSLATION.TRAVEL_BLOCK,
                showTravelInfo: false,
            }  
        },
        watch: {
            showTravelInfo() {
                this.$emit('showTravelInfo', this.showTravelInfo);
            }
        },
        methods: {
            toogleFlightSchedule() {
                if(this.legList.length) {
                    this.showTravelInfo = !this.showTravelInfo;
                }
            },
            formatTime(time) {
                return Moment(time).format('HH:mm');
            },
            humanizeTime(duration) {
                let timeStr = '';
                if(duration.hours() > 0) {
                    timeStr += duration.hours() + this.translations.hour_shorthand + ' ';
                }

                if(duration.minutes() > 0) {
                    timeStr += duration.minutes() + this.translations.minute_shorthand;
                }

                return timeStr;
            }
        },
        computed: {
            legList() {
                return (this.flightData && this.flightData.legList) ? this.flightData.legList : [ ];
            },
            airportTimes() {
                let airportTime = [ ];
                if(this.legList.length < 2) {
                    return airportTime;
                }

                let airportPairs = _.chunk(this.legList, 2)

                for(let i in airportPairs) {
                    let airportPair = airportPairs[i];
                    if(typeof airportPair[1] !== 'undefined') {
                        let time = this.humanizeTime(Moment.duration(Moment(airportPair[1].departureDateTime).diff(Moment(airportPair[0].arrivalDateTime))));
                        airportTime.push({
                            airport: airportPair[0].arrivalAirport,
                            time
                        });
                    }  
                }

                return airportTime;
            },
            firstLeg() {
                return (this.legList[0]) ? this.legList[0] : null;
            },
            lastLeg() {
                let key = this.legList.length - 1;
                return (this.legList[key]) ? this.legList[key] : null;
            },
            estimatedTime() {
                return (this.flightData && this.flightData.estimatedTime) ? Moment.duration(this.flightData.estimatedTime, 'seconds') : null;
            },
            departureTime() {
                return (this.firstLeg && this.firstLeg.departureDateTime) ? Moment(this.firstLeg.departureDateTime) : null;
            },
            arrivalTime() {
                return (this.lastLeg && this.lastLeg.arrivalDateTime) ? Moment(this.lastLeg.arrivalDateTime) : null;
            },
            formattedDate() {
                if(this.departureTime) {
                    return this.departureTime.format('DD. MMMM YYYY')
                } else if(this.flightData && this.flightData.travelDate) {
                    return Moment(this.flightData.travelDate).format('DD. MMMM. YYYY')
                }

                return null;
            },
            startTime() {
                return (this.departureTime) ? this.departureTime.format('HH:mm') : null;
            },
            startCity() {
                if(this.firstLeg && this.firstLeg.departureAirport) {
                    return this.firstLeg.departureAirport.name;
                } else if(this.flightData && this.flightData.airports) {
                    return (this.flightData.airports[0]) ? this.flightData.airports[0].name : null;
                }

                return null;
            },
            endTime() {
                return (this.arrivalTime) ? this.arrivalTime.format('HH:mm') : null;
            },
            endCity() {
                if(this.lastLeg && this.lastLeg.arrivalAirport) {
                    return this.lastLeg.arrivalAirport.name;
                } else if(this.flightData && this.flightData.airports) {
                    return (this.flightData.airports[1]) ? this.flightData.airports[1].name : null;
                }

                return null;
            },
            totalTime() {
                if(!this.estimatedTime) {
                    return '';
                }

                return this.humanizeTime(this.estimatedTime);
            },
            totalStops() {
                if(this.legList.length < 1) {
                    return null;
                } else if(this.legList.length == 1) {
                    return this.translations.direct_flight;
                }
                
                let numberOfStops = this.legList.length - 1;
                return (numberOfStops <= 1) ? numberOfStops + ' ' + this.translations.single_stop : numberOfStops + ' ' + this.translations.number_of_stops;
            }
        }
    }
</script>